var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicle6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64.000000pt",
    height: "64.000000pt",
    viewBox: "0 0 64.000000 64.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
    fill: "current",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263 426 c-13 -7 -20 -15 -17 -19 3 -3 1 -14 -4 -24 -10 -17 -11 -16 -21 7 -9 24 -10 24 -10 2 -1 -12 -10 -30 -21 -39 -11 -10 -20 -23 -20 -31 0 -26 -18 -2 -24 33 -11 58 -87 91 -128 57 -9 -7 -12 -26 -9 -54 3 -34 6 -39 12 -23 6 15 8 11 9 -20 1 -22 1 -50 0 -63 -2 -26 20 -37 56 -28 l27 7 -23 25 c-13 13 -28 24 -34 24 -7 0 -10 19 -8 50 5 62 19 61 49 -3 26 -54 56 -87 79 -87 8 0 22 -7 30 -15 20 -19 58 -19 74 0 7 9 29 15 50 15 21 0 41 6 43 13 3 6 6 2 6 -9 1 -32 25 -48 50 -34 12 6 21 18 21 26 0 8 5 12 10 9 6 -3 10 1 10 10 0 13 6 16 25 11 14 -4 48 -4 75 0 41 5 50 11 58 33 9 25 8 26 -34 26 -33 0 -43 -4 -41 -15 4 -24 -32 -23 -72 3 -20 13 -51 28 -68 31 -23 5 -34 15 -42 37 -7 21 -7 29 2 29 7 0 -1 7 -17 15 -33 18 -62 18 -93 1z m-163 -21 c14 -8 21 -14 15 -14 -5 0 -21 6 -35 14 -14 8 -20 14 -15 14 6 0 21 -6 35 -14z m260 -21 c13 -33 13 -34 -5 -34 -8 0 -15 -5 -15 -12 0 -7 -5 -5 -12 5 -7 9 -26 18 -42 21 -35 6 -38 9 -30 30 4 11 19 16 50 16 39 0 46 -3 54 -26z m-223 -46 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m147 -34 c22 -22 20 -31 -2 -11 -23 21 -56 22 -76 1 -9 -8 -16 -11 -16 -5 0 29 69 40 94 15z m-19 -44 c0 -16 -6 -26 -18 -28 -19 -4 -32 20 -23 44 9 25 41 13 41 -16z m165 -20 c0 -21 -24 -28 -35 -10 -8 14 3 30 21 30 8 0 14 -9 14 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230 260 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicle6);
export default __webpack_public_path__ + "static/media/vehicle6.bb59bf5217b9cca6145726c540e9de87.svg";
export { ForwardRef as ReactComponent };